import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    MainContainer,
    CartActionItems,
    AddIcon,
    Text,
    ItemsNotOrderScreenList,
    SetsNotOrderScreenList,
    FeesNotOrderScreenList,
    TrashIcon,
} from './MainContainerView.styled';
import StorageRequest from 'src/assets/images/storage-request.svg';
import TrashCanGrey from 'src/assets/images/trash-can-grey.svg';
import { Header } from 'src/pages/scheduleSurgery/components/surgery/SurgeryReviewAndSuccess.styled';
import { NoteSummaryContainer } from 'src/pages/scheduleSurgery/components/cart/Cart.styled';
import SummaryContainer from 'src/pages/equity/components/cart/SummaryContainer';
import ListView from 'src/common/organisms/listView/index.jsx';
import Button from 'src/common/refactoredComponents/button/Button';
import Summary from '../../../components/summary/index';
import { getTotalCount } from 'src/utils/util';
import {
    BASE_TEXT_PX,
    FONT_FAMILY_DEMI,
    PRIMARY_FONT_COLOR,
    SECONDARY_FONT_COLOR,
    SEMANTIC_TEXT_PX,
    SEMANTIC_TEXT_SMALL_PX,
    SMALL_TEXT_PX,
    X_LARGE_TEXT_PX,
    X_SMALL_TEXT_PX,
    XX_SMALL_TEXT_PX,
} from '../../../../styles/fonts/MCFontConstants';

const MainContainerView = ({
    isOrderScreen,
    isConsignmnetAdd,
    moreTemplates,
    isReviewSubmitScreenEquity,
    isTemplateDetail,
    sets,
    isOrderScreenListView,
    isReviewSubmitScreen,
    setImplant,
    setInstrument,
    handleBundlePopup,
    handleBundleSetItemClick,
    isSurgery,
    setsQuantityCheck,
    removeCount,
    addCount,
    handleSetItemClick,
    deleteProduct,
    isShippingScreen,
    inventoryShipping,
    handleLocationChange,
    isCondensedView,
    implantShipAll,
    checkAll,
    checked,
    checkSelectAllDisabled,
    selectAllDisabled,
    handleShipAllChange,
    isBatchSelected,
    setIsBatchSelected,
    selectedLocation,
    isTemplateScreen,
    isIndependentProductGuide,
    handleCheckBoxSelection,
    isEquityTemplate,
    isEquityPage,
    onBomClick,
    showDontShip,
    isCartScreen,
    isFromTemplates,
    instrumentShipAll,
    items,
    itemBundles,
    itemImplant,
    isConsignmentAdd,
    isEquityScreen,
    updateProductQuantity,
    itemInstrument,
    fees,
    feesImplant,
    feesInstrument,
    products,
    overridenDiscount,
    nonTissueSummary,
    tissueSummary,
    setsQuantityCount,
    itemsQuantityCount,
    isFromConsignmentAdd,
    onEmptyCategory,
}) => {
    const { t } = useTranslation();
    const { cartProducts } = useSelector((state) => ({
        cartProducts: state.surgeryReducer.cartData.products,
    }));
    const { isLanguageChanged } = useSelector((state) => state.loginReducer);
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const showCategoryDelete =
        isCartScreen && typeof onEmptyCategory === 'function';
    const renderCategoryDeleteIcon = (category, testIdSuffix) => {
        if (!showCategoryDelete) return null;
        return (
            <Button
                id={`category-delete-${testIdSuffix}`}
                data-testid={`category-delete-${testIdSuffix}`}
                show={true}
                clicked={() => onEmptyCategory(category)}
                backgroundColor={'transparent'}
                border={'none'}
                mbBorder={'none'}
                activeBorder={'none'}
                color={SECONDARY_FONT_COLOR}
                fontSize={XX_SMALL_TEXT_PX}
                fontFamily={FONT_FAMILY_DEMI}
                height={'auto'}
                mobileHeight={'auto'}
                width={'auto'}
                mobileWidth={'auto'}
                padding={'0'}
                mbPadding={'0'}
                margin={'0 12px 0 auto'}
                mobileMargin={'0 12px 0 auto'}
                borderRadius={'0'}
            >
                <TrashIcon src={TrashCanGrey} alt="" height="12px" width="12px" />
                <Text
                    color={SECONDARY_FONT_COLOR}
                    width={'auto'}
                    fontSize={XX_SMALL_TEXT_PX}
                    alignItems={'center'}
                    marginLeft={'4px'}
                >
                    {t('common.ClearSection')}
                </Text>
            </Button>
        );
    };
    const getTotalQuantity = (list) => {
        let totalCount = 0;
        let listCopy = [...list];
        if (moreTemplates) {
            listCopy = listCopy.filter((item) => !item.isTemplateEntryDeleted);
        }
        listCopy.map((e) => {
            totalCount += e.quantity;
        });
        return totalCount;
    };

    return (
        <>
            <MainContainer
                data-testid="main-container"
                isReviewSubmitScreen={
                    isOrderScreen
                        ? isOrderScreen
                        : isConsignmnetAdd
                        ? '1%'
                        : isReviewSubmitScreen
                }
                isConsignmnetAdd={'2%'}
                isOrderScreen={isOrderScreen}
                moreTemplates={moreTemplates}
                isReviewSubmitScreenEquity={isReviewSubmitScreenEquity}
                isTemplateDetail={isTemplateDetail}
            >
                {sets.length > 0 && (
                    <>
                        {!isOrderScreenListView && (
                            <SetsNotOrderScreenList>
                                {`${t('common.setsPascalCaseLabel')} (${
                                    isOrderScreen
                                        ? sets?.filter(
                                              (d) =>
                                                  d?.status !== 'キャンセル' &&
                                                  d?.status?.toLowerCase() !==
                                                      'cancel'
                                          ).length
                                        : sets.length
                                })`}
                                {isReviewSubmitScreen ? (
                                    cartProducts.some(
                                        (product) => product.isReservationSet
                                    ) && (
                                        <CartActionItems
                                            width={
                                                isLanguageChanged
                                                    ? '68px'
                                                    : '160px'
                                            }
                                            marginLeft={'5px'}
                                            marginTop={
                                                countryISOCode === 'JP' && '5px'
                                            }
                                        >
                                            {' '}
                                            <AddIcon
                                                display={'flex'}
                                                padding={'0px 5px 0px 0px'}
                                            >
                                                {' '}
                                                <img
                                                    width={X_LARGE_TEXT_PX}
                                                    src={StorageRequest}
                                                />{' '}
                                            </AddIcon>
                                            <Text
                                                width={'130px'}
                                                color={'#C121EB'}
                                                fontSize={'131q   px'}
                                            >
                                                {t(
                                                    'common.reservationRequired'
                                                )}
                                            </Text>
                                        </CartActionItems>
                                    )
                                ) : (
                                    <></>
                                )}
                            </SetsNotOrderScreenList>
                        )}
                        {setImplant?.length > 0 && (
                            <>
                                <Header
                                    mbPaddingLeft={X_LARGE_TEXT_PX}
                                    mbWidth={'calc(100%)'}
                                    paddingLeft={XX_SMALL_TEXT_PX}
                                    height={'38px'}
                                    mbHeight={'33px'}
                                    fontSize={X_SMALL_TEXT_PX}
                                    marginBottom={'7px'}
                                    background={
                                        '#EBEBEE 0% 0% no-repeat padding-box'
                                    }
                                >
                                    {`${t('common.tableView.implants')} (${
                                        isOrderScreen
                                            ? setImplant
                                                  ?.filter(
                                                      (d) =>
                                                          d?.status !==
                                                              'キャンセル' &&
                                                          d?.status?.toLowerCase() !==
                                                              'cancel'
                                                  )
                                                  ?.reduce(
                                                      (sum, currentItem) =>
                                                          sum +
                                                          parseInt(
                                                              currentItem.quantity ||
                                                                  0
                                                          ),
                                                      0
                                                  )
                                            : setImplant?.reduce(
                                                  (sum, currentItem) =>
                                                      sum +
                                                      parseInt(
                                                          currentItem.quantity ||
                                                              0
                                                      ),
                                                  0
                                              )
                                    })`}
                                    {renderCategoryDeleteIcon(
                                        'setImplant',
                                        'set-implant'
                                    )}
                                </Header>
                                <ListView
                                    handleBundlePopup={handleBundlePopup}
                                    handleBundleSetItemClick={
                                        handleBundleSetItemClick
                                    }
                                    isSurgery={isSurgery}
                                    products={setImplant}
                                    setsQuantityCheck={setsQuantityCheck}
                                    removeCount={removeCount}
                                    addCount={addCount}
                                    handleSetItemClick={handleSetItemClick}
                                    deleteProduct={deleteProduct}
                                    isShippingScreen={isShippingScreen}
                                    isReviewSubmitScreen={isReviewSubmitScreen}
                                    inventoryShipping={inventoryShipping}
                                    handleLocationChange={handleLocationChange}
                                    checkAll={
                                        isCondensedView
                                            ? !implantShipAll
                                            : checkAll
                                    }
                                    checked={checked}
                                    checkSelectAllDisabled={
                                        checkSelectAllDisabled
                                    }
                                    selectAllDisabled={selectAllDisabled}
                                    handleShipAllChange={handleShipAllChange}
                                    isBatchSelected={isBatchSelected}
                                    setIsBatchSelected={setIsBatchSelected}
                                    selectedLocation={selectedLocation}
                                    isTemplateScreen={isTemplateScreen}
                                    isIndependentProductGuide={
                                        isIndependentProductGuide
                                    }
                                    handleCheckBoxSelection={
                                        handleCheckBoxSelection
                                    }
                                    isOrderScreen={isOrderScreen}
                                    moreTemplates={moreTemplates}
                                    isEquityTemplate={isEquityTemplate}
                                    isEquityPage={isEquityPage}
                                    onBomClick={onBomClick}
                                    showDontShip={showDontShip}
                                    isCartScreen={isCartScreen}
                                    isFromTemplates={isFromTemplates}
                                    implantShipAll={implantShipAll}
                                    instrumentShipAll={instrumentShipAll}
                                    isImplant={true}
                                    isTemplateDetail={isTemplateDetail}
                                />
                            </>
                        )}
                        {setInstrument?.length > 0 && (
                            <>
                                <Header
                                    mbPaddingLeft={X_LARGE_TEXT_PX}
                                    mbWidth={'calc(100%)'}
                                    paddingLeft={XX_SMALL_TEXT_PX}
                                    height={'38px'}
                                    mbHeight={'33px'}
                                    fontSize={X_SMALL_TEXT_PX}
                                    marginBottom={'7px'}
                                    background={
                                        '#EBEBEE 0% 0% no-repeat padding-box'
                                    }
                                >
                                    {`${t('common.tableView.instruments')} (${
                                        isOrderScreen
                                            ? setInstrument
                                                  ?.filter(
                                                      (d) =>
                                                          d?.status !==
                                                              'キャンセル' &&
                                                          d?.status?.toLowerCase() !==
                                                              'cancel'
                                                  )
                                                  ?.reduce(
                                                      (sum, currentItem) =>
                                                          sum +
                                                          parseInt(
                                                              currentItem.quantity ||
                                                                  0
                                                          ),
                                                      0
                                                  )
                                            : setInstrument?.reduce(
                                                  (sum, currentItem) =>
                                                      sum +
                                                      parseInt(
                                                          currentItem.quantity ||
                                                              0
                                                      ),
                                                  0
                                              )
                                    })`}
                                    {renderCategoryDeleteIcon(
                                        'setInstrument',
                                        'set-instrument'
                                    )}
                                </Header>
                                <ListView
                                    handleBundlePopup={handleBundlePopup}
                                    handleBundleSetItemClick={
                                        handleBundleSetItemClick
                                    }
                                    isSurgery={isSurgery}
                                    products={setInstrument}
                                    setsQuantityCheck={setsQuantityCheck}
                                    removeCount={removeCount}
                                    addCount={addCount}
                                    handleSetItemClick={handleSetItemClick}
                                    deleteProduct={deleteProduct}
                                    isShippingScreen={isShippingScreen}
                                    isReviewSubmitScreen={isReviewSubmitScreen}
                                    inventoryShipping={inventoryShipping}
                                    handleLocationChange={handleLocationChange}
                                    checkAll={
                                        isCondensedView
                                            ? !instrumentShipAll
                                            : checkAll
                                    }
                                    checked={checked}
                                    checkSelectAllDisabled={
                                        checkSelectAllDisabled
                                    }
                                    selectAllDisabled={selectAllDisabled}
                                    handleShipAllChange={handleShipAllChange}
                                    isBatchSelected={isBatchSelected}
                                    setIsBatchSelected={setIsBatchSelected}
                                    selectedLocation={selectedLocation}
                                    isTemplateScreen={isTemplateScreen}
                                    isIndependentProductGuide={
                                        isIndependentProductGuide
                                    }
                                    handleCheckBoxSelection={
                                        handleCheckBoxSelection
                                    }
                                    isOrderScreen={isOrderScreen}
                                    moreTemplates={moreTemplates}
                                    isEquityTemplate={isEquityTemplate}
                                    isEquityPage={isEquityPage}
                                    onBomClick={onBomClick}
                                    showDontShip={showDontShip}
                                    isCartScreen={isCartScreen}
                                    isFromTemplates={isFromTemplates}
                                    implantShipAll={implantShipAll}
                                    instrumentShipAll={instrumentShipAll}
                                    isImplant={false}
                                    isTemplateDetail={isTemplateDetail}
                                />
                            </>
                        )}
                    </>
                )}
                {(items.length > 0 || itemBundles.length > 0) && (
                    <>
                        {!isOrderScreenListView && (
                            <ItemsNotOrderScreenList
                                marginTop={
                                    !isReviewSubmitScreenEquity &&
                                    items.length > 0 &&
                                    '1.5%'
                                }
                                fontSize={
                                    isOrderScreen || isReviewSubmitScreenEquity
                                        ? SEMANTIC_TEXT_PX
                                        : BASE_TEXT_PX
                                }
                            >
                                {isOrderScreen
                                    ? `${t('common.extraItems')} (${
                                          getTotalCount(
                                              items.filter(
                                                  (d) =>
                                                      d?.status !==
                                                          'キャンセル' &&
                                                      d?.status?.toLowerCase() !==
                                                          'cancel'
                                              )
                                          ) +
                                          getTotalCount(
                                              itemBundles.filter(
                                                  (d) =>
                                                      d?.status !==
                                                          'キャンセル' &&
                                                      d?.status?.toLowerCase() !==
                                                          'cancel'
                                              )
                                          )
                                      })`
                                    : `${t('common.itemsLabel')} (${
                                          items.reduce(
                                              (sum, currentItem) =>
                                                  sum +
                                                  parseInt(
                                                      currentItem.quantity || 0
                                                  ),
                                              0
                                          ) + getTotalCount(itemBundles)
                                      })`}
                            </ItemsNotOrderScreenList>
                        )}
                        {itemImplant?.length > 0 && (
                            <>
                                <Header
                                    mbPaddingLeft={XX_SMALL_TEXT_PX}
                                    mbWidth={'calc(100%)'}
                                    paddingLeft={XX_SMALL_TEXT_PX}
                                    height={'38px'}
                                    mbHeight={'33px'}
                                    fontSize={X_SMALL_TEXT_PX}
                                    marginBottom={'7px'}
                                    background={
                                        '#EBEBEE 0% 0% no-repeat padding-box'
                                    }
                                >
                                    {`${t('common.tableView.implants')} (${
                                        isOrderScreen
                                            ? itemImplant
                                                  ?.filter(
                                                      (d) =>
                                                          d?.status !==
                                                              'キャンセル' &&
                                                          d?.status?.toLowerCase() !==
                                                              'cancel'
                                                  )
                                                  ?.reduce(
                                                      (sum, currentItem) =>
                                                          sum +
                                                          parseInt(
                                                              currentItem.quantity ||
                                                                  0
                                                          ),
                                                      0
                                                  )
                                            : itemImplant?.reduce(
                                                  (sum, currentItem) =>
                                                      sum +
                                                      parseInt(
                                                          currentItem.quantity ||
                                                              0
                                                      ),
                                                  0
                                              )
                                    })`}
                                    {renderCategoryDeleteIcon(
                                        'itemImplant',
                                        'item-implant'
                                    )}
                                </Header>
                                <ListView
                                    handleBundlePopup={handleBundlePopup}
                                    handleBundleSetItemClick={
                                        handleBundleSetItemClick
                                    }
                                    products={itemImplant}
                                    setsQuantityCheck={setsQuantityCheck}
                                    removeCount={removeCount}
                                    addCount={addCount}
                                    handleSetItemClick={handleSetItemClick}
                                    deleteProduct={deleteProduct}
                                    isShippingScreen={isShippingScreen}
                                    isReviewSubmitScreen={isReviewSubmitScreen}
                                    inventoryShipping={inventoryShipping}
                                    handleLocationChange={handleLocationChange}
                                    checkAll={checkAll}
                                    checked={checked}
                                    checkSelectAllDisabled={
                                        checkSelectAllDisabled
                                    }
                                    selectAllDisabled={selectAllDisabled}
                                    handleShipAllChange={handleShipAllChange}
                                    isItem={true}
                                    isTemplateScreen={isTemplateScreen}
                                    isIndependentProductGuide={
                                        isIndependentProductGuide
                                    }
                                    handleCheckBoxSelection={
                                        handleCheckBoxSelection
                                    }
                                    isOrderScreen={isOrderScreen}
                                    moreTemplates={moreTemplates}
                                    isEquityTemplate={isEquityTemplate}
                                    isConsignmentAdd={isConsignmentAdd}
                                    isEquityScreen={isEquityScreen}
                                    isEquityPage={isEquityPage}
                                    isReviewSubmitScreenEquity={
                                        isReviewSubmitScreenEquity
                                    }
                                    onBomClick={onBomClick}
                                    showDontShip={showDontShip}
                                    isCartScreen={isCartScreen}
                                    isFromTemplates={isFromTemplates}
                                    isTemplateDetail={isTemplateDetail}
                                    updateProductQuantity={
                                        updateProductQuantity
                                    }
                                    isSurgery={isSurgery}
                                />
                            </>
                        )}
                        {itemInstrument?.length > 0 && (
                            <>
                                <Header
                                    mbPaddingLeft={X_LARGE_TEXT_PX}
                                    mbWidth={'calc(100%)'}
                                    paddingLeft={XX_SMALL_TEXT_PX}
                                    height={'38px'}
                                    mbHeight={'33px'}
                                    fontSize={X_SMALL_TEXT_PX}
                                    marginBottom={'7px'}
                                    background={
                                        '#EBEBEE 0% 0% no-repeat padding-box'
                                    }
                                >
                                    {`${t('common.tableView.instruments')} (${
                                        isOrderScreen
                                            ? itemInstrument
                                                  ?.filter(
                                                      (d) =>
                                                          d?.status !==
                                                              'キャンセル' &&
                                                          d?.status?.toLowerCase() !==
                                                              'cancel'
                                                  )
                                                  ?.reduce(
                                                      (sum, currentItem) =>
                                                          sum +
                                                          parseInt(
                                                              currentItem.quantity ||
                                                                  0
                                                          ),
                                                      0
                                                  )
                                            : itemInstrument?.reduce(
                                                  (sum, currentItem) =>
                                                      sum +
                                                      parseInt(
                                                          currentItem.quantity ||
                                                              0
                                                      ),
                                                  0
                                              )
                                    })`}
                                    {renderCategoryDeleteIcon(
                                        'itemInstrument',
                                        'item-instrument'
                                    )}
                                </Header>
                                <ListView
                                    handleBundlePopup={handleBundlePopup}
                                    handleBundleSetItemClick={
                                        handleBundleSetItemClick
                                    }
                                    products={itemInstrument}
                                    setsQuantityCheck={setsQuantityCheck}
                                    removeCount={removeCount}
                                    addCount={addCount}
                                    isSurgery={isSurgery}
                                    handleSetItemClick={handleSetItemClick}
                                    deleteProduct={deleteProduct}
                                    isShippingScreen={isShippingScreen}
                                    isReviewSubmitScreen={isReviewSubmitScreen}
                                    inventoryShipping={inventoryShipping}
                                    handleLocationChange={handleLocationChange}
                                    checkAll={checkAll}
                                    checked={checked}
                                    checkSelectAllDisabled={
                                        checkSelectAllDisabled
                                    }
                                    selectAllDisabled={selectAllDisabled}
                                    handleShipAllChange={handleShipAllChange}
                                    isItem={true}
                                    isTemplateScreen={isTemplateScreen}
                                    isIndependentProductGuide={
                                        isIndependentProductGuide
                                    }
                                    handleCheckBoxSelection={
                                        handleCheckBoxSelection
                                    }
                                    isOrderScreen={isOrderScreen}
                                    isEquityPage={isEquityPage}
                                    isReviewSubmitScreenEquity={
                                        isReviewSubmitScreenEquity
                                    }
                                    moreTemplates={moreTemplates}
                                    isEquityTemplate={isEquityTemplate}
                                    onBomClick={onBomClick}
                                    showDontShip={showDontShip}
                                    isCartScreen={isCartScreen}
                                    isFromTemplates={isFromTemplates}
                                    isTemplateDetail={isTemplateDetail}
                                    updateProductQuantity={
                                        updateProductQuantity
                                    }
                                />
                            </>
                        )}
                        {itemBundles?.length > 0 && (
                            <>
                                <Header
                                    mbPaddingLeft={X_LARGE_TEXT_PX}
                                    mbWidth={'calc(100%)'}
                                    paddingLeft={XX_SMALL_TEXT_PX}
                                    height={'38px'}
                                    mbHeight={'33px'}
                                    fontSize={X_SMALL_TEXT_PX}
                                    marginBottom={'7px'}
                                    background={
                                        '#EBEBEE 0% 0% no-repeat padding-box'
                                    }
                                >
                                    {`${t(
                                        'common.tableView.bundles'
                                    )} (${itemBundles?.reduce(
                                        (sum, currentItem) =>
                                            sum +
                                            parseInt(currentItem.quantity || 0),
                                        0
                                    )})`}
                                </Header>
                                <ListView
                                    handleBundlePopup={handleBundlePopup}
                                    handleBundleSetItemClick={
                                        handleBundleSetItemClick
                                    }
                                    products={itemBundles}
                                    setsQuantityCheck={setsQuantityCheck}
                                    removeCount={removeCount}
                                    addCount={addCount}
                                    handleSetItemClick={handleSetItemClick}
                                    deleteProduct={deleteProduct}
                                    isShippingScreen={isShippingScreen}
                                    isReviewSubmitScreen={isReviewSubmitScreen}
                                    inventoryShipping={inventoryShipping}
                                    handleLocationChange={handleLocationChange}
                                    checkAll={checkAll}
                                    checked={checked}
                                    checkSelectAllDisabled={
                                        checkSelectAllDisabled
                                    }
                                    selectAllDisabled={selectAllDisabled}
                                    handleShipAllChange={handleShipAllChange}
                                    isItem={true}
                                    isTemplateScreen={isTemplateScreen}
                                    isIndependentProductGuide={
                                        isIndependentProductGuide
                                    }
                                    handleCheckBoxSelection={
                                        handleCheckBoxSelection
                                    }
                                    moreTemplates={moreTemplates}
                                    isConsignmentAdd={isConsignmentAdd}
                                    isEquityPage={isEquityPage}
                                    isReviewSubmitScreenEquity={
                                        isReviewSubmitScreenEquity
                                    }
                                    onBomClick={onBomClick}
                                    showDontShip={showDontShip}
                                    isCartScreen={isCartScreen}
                                    isFromTemplates={isFromTemplates}
                                    isBundleView={true}
                                    isOrderScreen={isOrderScreen}
                                    isEquityTemplate={isEquityTemplate}
                                    isTemplateDetail={isTemplateDetail}
                                    updateProductQuantity={
                                        updateProductQuantity
                                    }
                                />
                            </>
                        )}
                    </>
                )}
                {fees.length > 0 && (
                    <>
                        {!isOrderScreenListView && (
                            <FeesNotOrderScreenList
                                isOrderScreen={isOrderScreen}
                            >
                                {t('common.feeLabel')} ({fees?.length})
                            </FeesNotOrderScreenList>
                        )}
                        {feesImplant?.length > 0 && (
                            <>
                                <ListView
                                    handleBundlePopup={handleBundlePopup}
                                    handleBundleSetItemClick={
                                        handleBundleSetItemClick
                                    }
                                    products={feesImplant}
                                    setsQuantityCheck={setsQuantityCheck}
                                    removeCount={removeCount}
                                    addCount={addCount}
                                    handleSetItemClick={handleSetItemClick}
                                    deleteProduct={deleteProduct}
                                    isShippingScreen={isShippingScreen}
                                    isReviewSubmitScreen={isReviewSubmitScreen}
                                    inventoryShipping={inventoryShipping}
                                    handleLocationChange={handleLocationChange}
                                    checkAll={checkAll}
                                    checked={checked}
                                    checkSelectAllDisabled={
                                        checkSelectAllDisabled
                                    }
                                    selectAllDisabled={selectAllDisabled}
                                    handleShipAllChange={handleShipAllChange}
                                    isBatchSelected={isBatchSelected}
                                    setIsBatchSelected={setIsBatchSelected}
                                    selectedLocation={selectedLocation}
                                    isTemplateScreen={isTemplateScreen}
                                    isIndependentProductGuide={
                                        isIndependentProductGuide
                                    }
                                    handleCheckBoxSelection={
                                        handleCheckBoxSelection
                                    }
                                    isOrderScreen={isOrderScreen}
                                    isEquityPage={isEquityPage}
                                    onBomClick={onBomClick}
                                    showDontShip={showDontShip}
                                    isCartScreen={isCartScreen}
                                    isFromTemplates={isFromTemplates}
                                    isTemplateDetail={isTemplateDetail}
                                    updateProductQuantity={
                                        updateProductQuantity
                                    }
                                />
                            </>
                        )}
                        {feesInstrument?.length > 0 && (
                            <>
                                <ListView
                                    handleBundlePopup={handleBundlePopup}
                                    handleBundleSetItemClick={
                                        handleBundleSetItemClick
                                    }
                                    products={feesInstrument}
                                    setsQuantityCheck={setsQuantityCheck}
                                    removeCount={removeCount}
                                    addCount={addCount}
                                    handleSetItemClick={handleSetItemClick}
                                    deleteProduct={deleteProduct}
                                    isShippingScreen={isShippingScreen}
                                    isReviewSubmitScreen={isReviewSubmitScreen}
                                    inventoryShipping={inventoryShipping}
                                    handleLocationChange={handleLocationChange}
                                    checkAll={checkAll}
                                    checked={checked}
                                    checkSelectAllDisabled={
                                        checkSelectAllDisabled
                                    }
                                    selectAllDisabled={selectAllDisabled}
                                    handleShipAllChange={handleShipAllChange}
                                    isBatchSelected={isBatchSelected}
                                    setIsBatchSelected={setIsBatchSelected}
                                    selectedLocation={selectedLocation}
                                    isTemplateScreen={isTemplateScreen}
                                    isIndependentProductGuide={
                                        isIndependentProductGuide
                                    }
                                    handleCheckBoxSelection={
                                        handleCheckBoxSelection
                                    }
                                    isOrderScreen={isOrderScreen}
                                    isConsignmentAdd={isConsignmentAdd}
                                    isEquityScreen={isEquityScreen}
                                    isEquityPage={isEquityPage}
                                    isReviewSubmitScreenEquity={
                                        isReviewSubmitScreenEquity
                                    }
                                    onBomClick={onBomClick}
                                    showDontShip={showDontShip}
                                    isCartScreen={isCartScreen}
                                    isFromTemplates={isFromTemplates}
                                    isTemplateDetail={isTemplateDetail}
                                    updateProductQuantity={
                                        updateProductQuantity
                                    }
                                />
                            </>
                        )}
                    </>
                )}

                {isCartScreen && (
                    <>
                        <NoteSummaryContainer
                            marginTop={'8px'}
                            marginBottom={SEMANTIC_TEXT_SMALL_PX}
                            flexDirection={isEquityPage && 'column'}
                        >
                            {isEquityPage ? (
                                <SummaryContainer
                                    fontSize={X_LARGE_TEXT_PX}
                                    margin={'10px 34px 14px 10px'}
                                    marginLeft={'0'}
                                    paddingBottom={'0px'}
                                    widthOnSmallDevice={'100%'}
                                    isUSUser={countryISOCode === 'US'}
                                    products={products}
                                    overridenDiscount={overridenDiscount}
                                    nonTissueSummary={nonTissueSummary}
                                    tissueSummary={tissueSummary}
                                    accountOwnedSummary={{
                                        qty: 1,
                                        orignalAmt: 400,
                                        discountAmt: 400,
                                    }}
                                />
                            ) : (
                                (setsQuantityCount >= 0 ||
                                    itemsQuantityCount >= 0) && (
                                    <Summary
                                        fontSize={X_LARGE_TEXT_PX}
                                        margin={'10px 34px 14px 10px'}
                                        marginLeft={'0'}
                                        widthOnSmallDevice={'100%'}
                                        numberOfSets={setsQuantityCount}
                                        numberOfExtraItems={itemsQuantityCount}
                                        height={'auto'}
                                        isFromReportPaymentScreen={false}
                                        isFromConsignment={false}
                                        summaryLabelColor={PRIMARY_FONT_COLOR}
                                        setFontSize={SMALL_TEXT_PX}
                                        totalFontSize={BASE_TEXT_PX}
                                        marginBottomCartScreen={
                                            XX_SMALL_TEXT_PX
                                        }
                                        isEquityPage={isEquityPage}
                                        isCondensedView={isCondensedView}
                                        mediumWidth={'100%'}
                                        isFromConsignmentAdd={
                                            isFromConsignmentAdd
                                        }
                                        instrumentItemFromKB={getTotalQuantity(
                                            itemInstrument
                                        )}
                                        implantableItemFromKB={getTotalQuantity(
                                            itemImplant
                                        )}
                                        isEquityTemplate={isEquityTemplate}
                                    />
                                )
                            )}
                        </NoteSummaryContainer>
                    </>
                )}
            </MainContainer>
        </>
    );
};

export default MainContainerView;
